import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthenticationService } from "@app/core/services";
import { environment } from "@env/environment";
import { Observable } from "rxjs";
import { IStripeSubscription, ISubscriptionResponse } from "../interfaces/stripe-payment";

@Injectable({ providedIn: 'root' })
export class StripePaymentService {

    constructor(private http: HttpClient,
        private accountService: AuthenticationService) { }

    public UpdateSubscription(newPriceKey: string): Observable<ISubscriptionResponse>  {
      return this.http.post<ISubscriptionResponse>(`${environment.apiUrl}api/billing/UpdateSubscription`, { NewPriceLookupKey: newPriceKey });
    }

    public CreateSubscripiton(priceKey: string) : Observable<ISubscriptionResponse> {
      return this.http.post<ISubscriptionResponse>(`${environment.apiUrl}api/billing/createsubscription`, { PriceId: priceKey });
    }

    public Pay() : Observable<ISubscriptionResponse> {
      return  this.http.get<ISubscriptionResponse>(`${environment.apiUrl}api/billing/GetPaymentElement`);
    }

    public CancelSubscription() {
       return this.http.post(`${environment.apiUrl}api/billing/CancelSubscription`, null);
    }

    public GetSubsctiptionInfo() : Observable<IStripeSubscription> {
       return this.http.get<IStripeSubscription>(`${environment.apiUrl}api/billing/GetSubscriptionInfo`);
    }

    public CustomerProtal() : Observable<UrlInfo> {
      return this.http.get<UrlInfo>(`${environment.apiUrl}api/billing/CustomerPortal`);
   }

  
}

export interface UrlInfo{
  url:string;
 }